module.exports = __webpack_public_path__ + "static/media/bell-slash.bc9e9228.svg";